import { IonCheckbox } from '@ionic/react'
import { SmartChargingConsideration } from '@vae/server/src/interfaces/eNode/eNodeSmartCharging.interface'
import { ENodeVehicle } from '@vae/server/src/interfaces/eNode/eNodeVehicle.interface'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
	consideration: SmartChargingConsideration | undefined
	vehicle: ENodeVehicle | null | undefined
	hasSmartPlan: boolean
}

const SmartChargingConsidering: React.FC<Props> = ({ consideration, vehicle, hasSmartPlan }) => {
	const { t } = useTranslation('pages_electricCar')

	const considerations = useMemo(() => {
		return [
			{
				key: 'isCarAtChargingLocation',
				label: t('smartChargingConsidering.syy9'),
				value: !!vehicle?.location.id,
			},
			{
				key: 'isCarPluggedIn',
				label: t('smartChargingConsidering.syy4'),
				value: !!vehicle?.chargeState?.isPluggedIn,
			},
			{
				key: 'hasSmartChargingEnabled',
				label: t('smartChargingConsidering.reason10'),
				value: vehicle?.smartChargingPolicy.isEnabled,
			},
			{ key: 'hasSmartPlan', label: t('smartChargingConsidering.syy2'), value: hasSmartPlan },
		]
	}, [vehicle])

	return (
		<div className='smart-charging-considering pb-4'>
			<h2 className='text-text-dark dark:text-white'>{t('smartChargingConsidering.otsikko')}</h2>

			<div className='flex flex-col items-center justify-center space-y-3 px-4'>
				{considerations.map(({ key, label, value }) => {
					return (
						<div key={key} className='flex items-center justify-start w-full max-w-xs'>
							<IonCheckbox
								id={key}
								checked={value}
								disabled
								color={
									consideration && Object.values(consideration).every(Boolean)
										? 'success'
										: undefined
								}
								className='m-0 dark:[--border-color:#3cb49f] dark:[--border-color-checked:#3cb49f] dark:[--checkbox-background-checked:#3cb49f] dark:[--checkbox-background:#144448] [--border-color:#52ae32] [--border-color-checked:#52ae32] [--checkbox-background-checked:#52ae32] [--checkbox-background:#cae3cc]'
							/>
							<label htmlFor={key} className='text-text-dark dark:text-white flex-1'>
								{label}
							</label>
						</div>
					)
				})}
			</div>
		</div>
	)
}
export default SmartChargingConsidering
